import { mapState } from "vuex";
// 默认导出
export default {
  data() {
    return {
      // 导航栏
      activeName: "homePage",
      // 首页搜索框
      inputPic: "",
      // 面包屑导航title
      title: null,
      // 各交易中心、监管局下拉框
      centreSupervise:{
        options: [{
          value: '1',
          label: '武汉市公告交易中心'
        }, {
          value: '2',
          label: '鄂州市行政审批局'
        }, {
          value: '3',
          label: '湖北省公共资源交易中心'
        }, {
          value: '4',
          label: '湖北省公共资源交易监督管理局'
        }],
        value: ''
      },
      // 主管部门网站下拉框
      competentDepartment:{
        options: [{
          value: '1',
          label: '鄂州市水利和湖泊局'
        }, {
          value: '2',
          label: '鄂州市住房和城乡建设局'
        }],
        value: ''
      },
      // 行业协会链接下拉框
      industryAssociations:{
        options: [{
          value: '1',
          label: '湖北省公共服务平台'
        }, {
          value: '2',
          label: '中国采招网'
        }],
        value: ''
      },
      // 政府事业单位网站下拉框
      governmentAgency:{
        options: [{
          value: '1',
          label: '鄂州市行政服务中心'
        }, {
          value: '2',
          label: '信用湖北'
        }, {
          value: '3',
          label: '湖北省公共资源招投标交易平台'
        }, {
          value: '4',
          label: '鄂州文明网'
        },{
          value: '5',
          label: '鄂州市政府门户网站'
        }, {
          value: '6',
          label: '信用鄂州'
        }],
        value: ''
      }
    };
  },
  // 计算属性
  computed: {
    // 当前路由是否是详情
    isDetailsPath() {
      if (this.$route.path.indexOf("Details") > -1) {
        return true;
      } else {
        return false;
      }
    },
    // 获取面包屑导航title
    ...mapState(["cmsTitle"])
    // getTitle() {
    //   if (this.$route.meta.title) {
    //     const title = this.$route.meta.title;
    //     this.title = title;
    //   }
    // }
  },
   // 模板编译完成
   mounted() {
    // 页面title
    document.title = '鄂州市公共资源交易网历史数据查询'
  },
  // 自定义方法
  methods: {
    // 头部导航栏
    fun_HandleClick(tab, event) {
      // 判断点击的导航栏
      if(tab.name==='homePage'){
        // 跳转 系统首页
        window.open("https://www.ezggzy.cn/CPRTS/");
      }else if(tab.name==='industryTrends'){
        // 跳转 行业动态
        window.open("https://www.ezggzy.cn/CPRTS/wz/201311080946010001/xydt/201601211113250008.html");
      }else if(tab.name==='evaluationBid'){
        // 跳转 评标结果公示
        window.open("https://www.ezggzy.cn/CPRTS/WinningPublicityInfoListInit.do");
      }else if(tab.name==='download'){
        // 跳转 下载中心
        window.open("https://www.ezggzy.cn/CPRTS/DownLoadInfoListInit.do");
      }else if(tab.name==='interaction'){
        // 跳转 互动交流
        window.open("https://www.ezggzy.cn/CPRTS/wz/201311080946010001/hdjl1/201806011921250012.html");
      }else if(tab.name==='commonProblem'){
        // 跳转 常见问题
        window.open("https://www.ezggzy.cn/CPRTS/wz/201311080946010001/cjwt/201312261014070015.html");
      }else if(tab.name==='creditExpert'){
        // 跳转 专家信用
        window.open("https://www.ezggzy.cn/CPRTS/wz/201311080946010001/zjxy/201312261021020021.html");
      }else{
        // 跳转 关于我们
        window.open("https://www.ezggzy.cn/CPRTS/wz/201311080946010001/gywm/201312261014290017.html");
      }
    },
    // 各交易中心、监管局下拉框
    fun_ChangeCentreSupervise(){
      // 判断跳转页面
      if(this.centreSupervise.value==='1'){
         // 跳转 武汉市公共资源交易中心
         window.location.href = 'https://www.whzbtb.com/V2PRTS/';
      }else if(this.centreSupervise.value==='2'){
        // 跳转 鄂州市行政审批局
        window.location.href = 'http://zwfwzx.ezhou.gov.cn/ggzyjg/';
      }else if(this.centreSupervise.value==='3'){
        // 跳转 湖北省公共资源交易中心
        window.location.href = 'http://www.hbggzy.cn/';
      }else{
        // 跳转 湖北省公共资源交易监督管理局
        window.location.href = 'https://ztb.hubei.gov.cn/';
      }
    },
    // 主管部门网站下拉框
    fun_ChangeCompetentDepartment(){
      // 判断跳转页面
      if(this.competentDepartment.value==='1'){
        // 跳转 鄂州市水利和湖泊局
        window.location.href = 'http://slhp.ezhou.gov.cn/';
        }else{
        // 跳转 鄂州市住房和城乡建设局
        window.location.href = 'http://cjw.ezhou.gov.cn/';
      }
    },
    // 行业协会链接下拉框
    fun_ChangeIndustryAssociations(){
      // 判断跳转页面
      if(this.industryAssociations.value==='1'){
        // 跳转 湖北省公共服务平台
        window.location.href = 'https://www.hbggzyfwpt.cn/';
        }else{
        // 跳转 中国采招网
        window.location.href = 'https://www.bidcenter.com.cn/';
      }
    },
    // 政府事业单位网站下拉框
    fun_ChangeGovernmentAgency(){
      // 判断跳转页面
      if(this.governmentAgency.value==='1'){
         // 跳转 鄂州市行政服务中心
         window.location.href = 'http://zwfwzx.ezhou.gov.cn/ggzyjg/';
      }else if(this.governmentAgency.value==='2'){
        // 跳转 信用湖北
        window.location.href = 'http://credit.hubei.gov.cn/';
      }else if(this.governmentAgency.value==='3'){
        // 跳转 湖北省公共资源招投标交易平台
        window.location.href = 'http://www.hbbidcloud.cn/';
      }else if(this.governmentAgency.value==='4'){
        // 跳转 鄂州文明网
        window.location.href = 'http://hbez.wenming.cn/';
      }else if(this.governmentAgency.value==='5'){
        // 跳转 鄂州市政府门户网站
        window.location.href = 'http://www.ezhou.gov.cn/sy/';
      }else{
        // 跳转 信用鄂州
        window.location.href = 'http://credit.ezhou.gov.cn/';
      }
    },
  }
};
